//######################### Base #########################
export const EncounterFeedSource = {
    User: 'user',
    Automatic: 'automatic',
};
//######################### Individual Types #########################
export const EncounterFeedType = {
    ProtocolNavigation: 'protocol-navigation',
    ProtocolConsiderationSwitch: 'protocol-consideration-level-switch',
    OrderSent: 'order-sent',
    OrderResulted: 'order-resulted',
};
//# sourceMappingURL=types.js.map